import React from 'react';
import { useTemplateConfig } from '../../../context/TemplateConfigContext';
import NotFoundPageDefault from './NotFoundPage';

const NotFoundPageShell = (props) => {
    const { componentOverrides = {} } = useTemplateConfig();
    const Override = componentOverrides.NotFoundPageComponent;

    if (Override) {
        return <Override {...props} />;
    }

    return <NotFoundPageDefault {...props} />;
};

export default NotFoundPageShell;
